import type {
  IAudienceTemplate,
  IAudienceTemplatePayload,
} from '@/Interfaces/AudienceTemplates/AudienceTemplate.interface';
import axios from 'axios';

const audienceTemplatesEndpoint = '/audience-templates';
const audienceTemplateWithIdEndpoint = (id: IAudienceTemplate['id']) => `${audienceTemplatesEndpoint}/${id}`;

export const fetchAudienceTemplates = async (): Promise<IAudienceTemplate[]> => {
  const response = await axios.get<IAudienceTemplate[]>(audienceTemplatesEndpoint);
  return response.data ?? [];
};

export const createAudienceTemplate = async (payload: IAudienceTemplatePayload): Promise<IAudienceTemplate> => {
  const response = await axios.post<IAudienceTemplate>(audienceTemplatesEndpoint, payload);
  return response.data;
};

export const updateAudienceTemplate = async (
  id: IAudienceTemplate['id'],
  payload: IAudienceTemplatePayload,
): Promise<IAudienceTemplate> => {
  const response = await axios.put<IAudienceTemplate>(audienceTemplateWithIdEndpoint(id), payload);
  return response.data;
};

export const deleteAudienceTemplate = async (id: IAudienceTemplate['id']): Promise<void> => {
  await axios.delete(audienceTemplateWithIdEndpoint(id));
};
